











































































































































import { defineComponent, ref } from "@vue/composition-api";
import useContact from "@/store/useContact";
import ContactViewModel from "@/models/ContactViewModel";
import { VueTelInput } from "vue-tel-input";

export default defineComponent({
    components: {
        VueTelInput,
        ConfirmDialog: () =>
            import(/* webpackChunkName: "settings" */ "./components/Dialogs/ConfirmDialog.vue")
    },
    setup(_, context) {
        const { update, get, remove, nameRules, emailRules } = useContact();
        const contactForm = ref<HTMLFormElement>();
        const contact = ref<ContactViewModel>();
        const id = parseInt(context.root.$route.params.id);
        const valid = ref<boolean>(true);
        const showConfirm = ref<boolean>(false);
        const showSuccess = ref<boolean>(false);

        const goBack = () => {
            window.history.back();
        };

        const successOk = () => {
        };

        const initSave = () => {
            if (contactForm.value) {
                valid.value = contactForm.value.validate();
                if (valid.value && contact.value) {
                    update(contact.value).then(() => {
                        showSuccess.value = true;
                    });
                }
            }
        };

        const vueTel = {
            phone: "",
            props: {
                autoFormat: true,
                autoDefaultCountry: true,
                dropdownOptions: {
                    showDialCodeInList: true,
                    showDialCodeInSelection: false,
                    showFlags: true,
                    showSearchBox: true,
                    width: '300px',
                },
                ignoredCountries: ["KP", "RU"],
                inputOptions: {
                    autocomplete: 'on',
                    showDialCode: true,
                    placeholder: 'Enter phone number',
                    required: true,
                },
                mode: "international",
                preferredCountries: ["DK", "NO", "SE"],
                validCharactersOnly: true,
            }
        };

        const initRemove = () => {
            showConfirm.value = true;
        };

        const confirmOk = () => {
            remove(id).then(() => {
                window.history.back();
            });
        };

        get(id).then((model: ContactViewModel) => {
            contact.value = model;
        });

        

        return {
            contactForm,
            valid,
            contact,
            nameRules,
            emailRules,
            initRemove,
            initSave,
            confirmOk,
            successOk,
            showConfirm,
            showSuccess,
            goBack,
            vueTel,
        };
    },
    data: () => ({
        isValid: false,
    }),
    methods: {
        phoneObject: function (object) {
            console.log(object);
            if (object.valid === true) {
                this.isValid = true;
            } else {
                this.isValid = false;
            }
        },
    }
});
